export default function displayItReducer(state = {
  display_it: [],
  display_it_objectives: [],
  meta: {},
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_DISPLAY_IT_PENDING':
    case 'ADD_DISPLAY_IT_PENDING':
    case 'GET_DISPLAY_IT_META_PENDING':
    case 'GET_DISPLAY_IT_OBJECTIVES_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_DISPLAY_IT_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        display_it: action.payload.data
      };
    }
    case 'ADD_DISPLAY_IT_FULFILLED': {
      return {
        ...state
      };
    }
    case 'GET_DISPLAY_IT_META_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        meta: action.payload
      };
    }
    case 'GET_DISPLAY_IT_OBJECTIVES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        display_it_objectives: action.payload.data
      };
    }
    case 'GET_DISPLAY_IT_REJECTED':
    case 'ADD_DISPLAY_IT_REJECTED':
    case 'GET_DISPLAY_IT_META_REJECTED':
    case 'GET_DISPLAY_IT_OBJECTIVES_REJECTED': {
      return { ...state };
    }
    default: {
      return { ...state };
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/displayItReducer.js